<script>
  import { Link } from "svelte-routing";
  import {
    Col,
    Container,
    Row,
    Table,
    Card,
    CardBody,
    CardTitle,
    Button,
    Label,
    Input,
    Form,
  } from "sveltestrap";
  import { chart } from "svelte-apexcharts";

  import Breadcrumb from "../../../common/Breadcrumb.svelte";  
var emailid = 'admin@themesbrand.com';




</script>

<div class="page-content">
  <Container fluid>
    <Breadcrumb title="Dashboard" breadcrumbItem="Perfil" />

    <Row>
      <Col xl="12">
        <Card class="overflow-hidden">
          <div class="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div class="text-primary p-3">
                  <h3 class="text-primary">Hola Juan Pablo!</h3>
                  <p>Bienvenido a tu perfil</p>
                </div>
              </Col>
              <Col xs="4" class="align-self-end">
                <img
                  src="assets/images/profile-img.png"
                  alt=""
                  class="img-fluid"
                />
              </Col>
            </Row>
          </div>
          <CardBody class="pt-0">
            <Row>
              <Col sm="12">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                    src="/assets/images/users/avatar-1.jpeg"
                    alt=""
                    class="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 class="font-size-15 text-truncate">Juan Pablo Vargas</h5>
                <p class="text-muted mb-0 text-truncate">Administrador</p>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <CardTitle class="mb-4 h4">Información Personal</CardTitle>
            <p class="text-muted mb-4">
             Aqui encontraras la información relacionada a tu perfil.
            </p>

            <div class="table-responsive">
              <div class="table-responsive">
                <Table class="table-nowrap mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Nombre :</th>
                      <td>Juan Pablo Vargas</td>
                    </tr>
                    <tr>
                      <th scope="row">Rol :</th>
                      <td>Administrador</td>
                    </tr>
                    <tr>
                      <th scope="row">E-mail :</th>
                      <td>juanp.vargas@enteleqqia.com</td>
                    </tr>
                    <tr>
                      <th scope="row">Empresa :</th>
                      <td>Enteleqqia</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <br>
            <div class="text-end">
              <Link to="/">
                <Button
                  color="primary"
                  class="w-md waves-effect waves-light"
                  type="submit">Editar datos
                </Button>
            </Link>
            </div>
          </CardBody>
         
        </Card>

        <Card>
          <CardBody>
              <CardTitle class="mb-4 h4">Contraseña</CardTitle>
              <p class="text-muted mb-4">
                  Aquí puedes cambiar tu contraseña
              </p>
              <div class="mb-3">
                  <Label for="userpassword">Contraseña actual</Label>
                  <Input
                      type="password"
                      class="form-control"
                      id="userpassword"
                      placeholder="JpVargas01!"
                  />
              </div>
              <div class="mb-3" id="nuevasContrasenas" style="display: none;">
                  <Label for="newpassword">Nueva contraseña</Label>
                  <Input
                      type="password"
                      class="form-control"
                      id="newpassword"
                      placeholder="Escribe tu nueva contraseña"
                  />
                  <br>
                  <Label for="confirmpassword">Confirmar nueva contraseña</Label>
                  <Input
                      type="password"
                      class="form-control"
                      id="confirmpassword"
                      placeholder="Confirmar tu nueva contraseña"
                  />
              </div>
              <div class="text-end">
                  <Button
                      color="primary"
                      class="w-md waves-effect waves-light"
                      type="button"
                      onclick="mostrarCampos()"
                  >
                      Cambiar contraseña
                  </Button>
              </div>
          </CardBody>
      </Card>
      <script>
        function mostrarCampos() {
        const nuevasContrasenas = document.getElementById('nuevasContrasenas');
        nuevasContrasenas.style.display = 'block';
    }
      </script>
    
      
      </Col>
    </Row>
  </Container>
</div>
